import { FieldsStep } from '../steps/FieldsStep';

/** Step 6, Writing guidelines: the one-column table of rules with its add box (spec:265). */
export function GuidelinesStep({ disabled = false }: { disabled?: boolean }) {
  return <FieldsStep step={6} disabled={disabled} />;
}
